
namespace TabAurous.Reports {
    import fld = TabAurous.Stock.StockItemRow.Fields;
    @Serenity.Decorators.registerClass()
    export class StockByPurchaseApprovalGrid extends _Ext.GridBase<TabAurous.Stock.StockItemRow, any> {
        protected getColumnsKey() { return 'Reports.StockByPurchaseApproval'; }
        protected getIdProperty() { return "id"; }
        protected getLocalTextPrefix() { return TabAurous.Stock.StockItemRow.localTextPrefix; }
        protected getService() { return TabAurous.Stock.StockByPurchaseApprovalService.baseUrl; }
        constructor(container: JQuery) {
            super(container);
            (this.view.params as ReportFiltersRequest).ItemTypeId = 101;
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();


            //var plugin = new Slick.ColumnGroup();
            //grid.registerPlugin(plugin);
            //var columns = grid.getColumns();
            //plugin.enableColumnGrouping();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

 
            return grid;
        }
         
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }
        protected getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
           
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: TabAurous.Stock.StockByPurchaseApprovalService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            return buttons;
        }
    }
}